import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import LoadingSpinnerTsoPq from '@components/LoadingSpinners/LoadingSpinnerTsoPq';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled } from '@mui/material';

export const StyledMeasurmentExport = styled(Box)(() => {
  return {
    width: '73.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24}`,
    background: tsoPqTheme.palette.background.other.color_other_background_white,
  };
});

export const StyledParametersContainer = styled(Box)(() => {
  return {
    width: '73.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4,
  };
});

export const StyledParameters = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
    background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_lt,
    padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
  };
});

export const StyledParametersLine = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  };
});

export const StyledButtonContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
  };
});

export const StyledDownloadPlaceholder = styled(Box, {
  shouldForwardProp: (prop) => !['showBorder'].includes(prop as string),
})(({ showBorder }: { showBorder: boolean }) => {
  return {
    width: '69.5.5rem',
    display: 'flex',
    flexDirection: 'column',
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_48} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24}`,
    textAlign: 'center',
    rowGap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
    border: showBorder ? `1px solid ${tsoPqTheme.palette.stroke.color_neutral_stroke_str_ntrl_accent}` : 'none',
  };
});

export const StyledImage = styled('img')(() => {
  return {
    display: 'flex',
    height: '12.375rem',
    width: '18.75rem',
    alignSelf: 'center',
  };
});

export const StyledSectionWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['selectDevice', 'customWidth'].includes(prop as string),
})(({ selectDevice, customWidth }: { selectDevice?: boolean; customWidth?: string }) => {
  return {
    width: customWidth ?? '31.5rem',
    display: 'flex',
    padding: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: selectDevice ? '4px' : tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
    alignSelf: 'stretch',
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
    background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_lt,
  };
});

export const StyledDeviceSelectionContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4,
  };
});

export const StyledFileIcon = styled(FontAwesomeIcon)(() => {
  return {
    color: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent,
    fontSize: '3.75rem',
    alignSelf: 'center',
  };
});

export const StyledTitleIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => !['error'].includes(prop as string),
})(({ error }: { error?: boolean }) => {
  return {
    color: error
      ? tsoPqTheme.palette.customError.color_signal_error_error
      : tsoPqTheme.palette.customTextColor.color_primary_font_ft_prim_accent,
    margin: `0 0.75rem 0 0`,
    fontSize: '1.375rem',
  };
});

export const StyledLoadingSpinnerTsoPq = styled(LoadingSpinnerTsoPq)(() => {
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 1,
  };
});

export const StyledSpinnerBackground = styled(Box)(() => {
  return {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `${tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_dark}20`,
    zIndex: 9999,
  };
});

export const StyledExportButton = styled(ButtonTsoPq)(() => {
  return {
    width: 'fit-content',
    alignSelf: 'center',
  };
});
